import React from 'react'

function WithdrawIcon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
      <g clipPath="url(#clip0_23_454)">
        <path d="M22.2516 6.28425L35.9172 30.0139C36.875 31.6858 35.6375 33.7499 33.6657 33.7499H6.33441C4.36253 33.7499 3.12503 31.6858 4.08285 30.0139L17.7485 6.28425C18.7328 4.57175 21.2672 4.57175 22.2516 6.28425Z" fill="#FF0000" />
        <path d="M20 23V15" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 29.9999C21.0355 29.9999 21.875 29.1604 21.875 28.1249C21.875 27.0893 21.0355 26.2499 20 26.2499C18.9645 26.2499 18.125 27.0893 18.125 28.1249C18.125 29.1604 18.9645 29.9999 20 29.9999Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_23_454">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WithdrawIcon